'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TocItem = require('./TocItem');

var _TocItem2 = _interopRequireDefault(_TocItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PreferencesDropDownMenu = function (_Component) {
  _inherits(PreferencesDropDownMenu, _Component);

  function PreferencesDropDownMenu(props) {
    _classCallCheck(this, PreferencesDropDownMenu);

    var _this = _possibleConstructorReturn(this, (PreferencesDropDownMenu.__proto__ || Object.getPrototypeOf(PreferencesDropDownMenu)).call(this, props));

    _this.state = { isActive: false };
    //bind this to toggleIsActive
    _this.toggleIsActive = _this.toggleIsActive.bind(_this);
    _this.onViewPreferencesClick = _this.onViewPreferencesClick.bind(_this);
    _this.onResetFilterClick = _this.onResetFilterClick.bind(_this);
    _this.onKeyUp = _this.onKeyUp.bind(_this);
    _this.onSavePreferencesClick = _this.onSavePreferencesClick.bind(_this);
    return _this;
  }

  //set's isActive to value, or flips isActives value if value is null


  _createClass(PreferencesDropDownMenu, [{
    key: 'toggleIsActive',
    value: function toggleIsActive(value) {
      if (value === undefined || value === null) {
        this.setState({ isActive: !this.state.isActive });
      } else {
        this.setState({ isActive: value });
      }
    }
  }, {
    key: 'onViewPreferencesClick',
    value: function onViewPreferencesClick() {
      this.toggleIsActive();
    }
  }, {
    key: 'onResetFilterClick',
    value: function onResetFilterClick() {
      this.props.resetFilterCB();
    }
  }, {
    key: 'onSavePreferencesClick',
    value: function onSavePreferencesClick() {
      this.props.saveUserPreferencesCB();
    }
  }, {
    key: 'onKeyUp',
    value: function onKeyUp(e) {
      if (e.keyCode === 27) //if escape key
        this.toggleIsActive(false);
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var menuRender = null;
      if (this.state.isActive === true) {
        menuRender = _react2.default.createElement(
          'div',
          { className: 'preferencesMenu dropShadow' },
          _react2.default.createElement(
            'div',
            { className: 'tocList' },
            this.props.sectionsArray.map(function (sectionData, index) {
              var moveUpEnabled = index !== 0;
              var moveDownEnabled = index !== this.props.sectionsArray.length - 1;
              return _react2.default.createElement(_TocItem2.default, _extends({}, sectionData, {
                key: sectionData.id,
                title: sectionData.name,
                isVisible: sectionData.isVisible,
                moveUpEnabled: moveUpEnabled,
                moveDownEnabled: moveDownEnabled,
                moveSectionCB: this.props.moveSectionCB,
                toggleVisibleCB: this.props.toggleVisibleCB,
                resetFilterCB: this.props.resetFilterCB,
                saveUserPreferencesCB: this.props.saveUserPreferencesCB,
                scrollToSectionCB: this.props.scrollToSectionCB
              }));
            }, this)
          ),
          _react2.default.createElement(
            'div',
            { className: 'tocBottomBar' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'button',
                  onClick: this.onSavePreferencesClick,
                  className: 'save-reset-Filter-Button',
                  title: 'Save Preferences' },
                'Save Preferences'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'button',
                  onClick: this.onResetFilterClick,
                  className: 'button save-reset-Filter-Button',
                  title: 'Reset Preferences' },
                'Reset Preferences'
              )
            )
          )
        );
      }
      return menuRender;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'preferencesDropDownMenu', onKeyUp: this.onKeyUp },
        _react2.default.createElement(
          'button',
          { onClick: this.onViewPreferencesClick, type: 'button', className: 'ccd-btn btn-rectangle btn-transparentBG viewPreferencesButton', title: 'Show/Hide Menu' },
          _react2.default.createElement('img', { className: 'indent-5 verticalAlign', src: require('../resources/icons/CCD-Icon-20.png'), alt: 'Show/Hide Menu', width: '30', height: '30' }),
          _react2.default.createElement(
            'span',
            { className: 'indent-10 hideOnSmallScreen' },
            'View Preferences'
          )
        ),
        this.renderMenu()
      );
    }
  }]);

  return PreferencesDropDownMenu;
}(_react.Component);

PreferencesDropDownMenu.propTypes = {
  sectionsArray: _propTypes2.default.array,
  saveUserPreferencesCB: _propTypes2.default.func,
  toggleVisibleCB: _propTypes2.default.func,
  moveSectionCB: _propTypes2.default.func,
  resetFilterCB: _propTypes2.default.func,
  scrollToSectionCB: _propTypes2.default.func
};

exports.default = PreferencesDropDownMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/PreferencesDropDownMenu.js
// module id = 1236
// module chunks = 0